// frontend/src/components/PrivacyPolicyModal.jsx
//
// Deliberately NOT lazy-loaded. This modal must be able to open the instant
// someone lands on `yoursite.com/#PrivacyPolicy` — a link that can be shared
// externally (email, SMS, ads) — so it can't depend on a separate, below-
// the-fold JS chunk (like Footer's) finishing its own network request first.
// On a slow connection that chunk can take a very long time to arrive,
// during which the popup would be unreachable even though the hash is
// already in the URL. Keeping this component in the main bundle guarantees
// it's ready as soon as the app boots.
import { useEffect, useState } from "react";
import "./PrivacyPolicyModal.css";

export default function PrivacyPolicyModal() {
  const [show, setShow] = useState(false);

  // Opens on a direct/external link straight to #PrivacyPolicy, and again
  // any time the hash is set to #PrivacyPolicy while already on the page
  // (e.g. the footer's "View Privacy Policy" link, which just sets the
  // hash rather than managing its own modal state).
  useEffect(() => {
    const checkHash = () => {
      if (window.location.hash === "#PrivacyPolicy") setShow(true);
    };
    checkHash();
    window.addEventListener("hashchange", checkHash);
    return () => window.removeEventListener("hashchange", checkHash);
  }, []);

  // Clears the #PrivacyPolicy hash on close so refreshing (or hitting Back)
  // doesn't immediately reopen the popup. Wrapped in try/catch: some
  // hosting setups (file://, sandboxed iframe previews) throw a
  // SecurityError on history.replaceState — that must never block the
  // popup itself from opening/closing.
  const close = () => {
    setShow(false);
    if (window.location.hash === "#PrivacyPolicy") {
      try {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
      } catch {
        /* non-fatal — URL just keeps the #PrivacyPolicy hash */
      }
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="privacy-backdrop" onClick={close} />
      <div className="privacy-modal" role="dialog" aria-modal="true" aria-label="Privacy Policy">
        <button className="privacy-modal__close" onClick={close} aria-label="Close">×</button>
        <h2>Privacy Policy</h2>
        <section>
          <p>We respect everyone's personal and confidential information...</p>
        </section>
        <section>
          <h3>Data Collection</h3>
          <ul>
            <li>Data on usage history or pattern on the website.</li>
            <li>Data provided on the website for subscribing to any products or services.</li>
            <li>Data related to transaction details made through the website.</li>
          </ul>
        </section>
        <section>
          <h3>Data Usage</h3>
          <ul>
            <li>To showcase products and services as per browsing history.</li>
            <li>To serve the products and services transacted on the website.</li>
            <li>To send you statements, product notes, or any notifications.</li>
          </ul>
        </section>
      </div>
    </>
  );
}
